module.exports = __webpack_public_path__ + "img/zoom_one_pro_addon.29ac7405.svg";